<template>
	<div class="columns">
		<div class="column">
			<div class="card">
				<header class="card-header">
				<p class="card-header-title">
					Top 5 Psychics by Revenue -&nbsp;Current Period
				</p>
				</header>
				<div class="card-table">
					<div class="content">
						<table class="table is-fullwidth is-striped">
						<thead>
						<tr>
							<th>
								#
							</th>
							<th>
								Psychic
							</th>
							<th class="is-hidden-mobile">
								<abbr title="Extension">Ext</abbr>
							</th>
							<th>
								Calls
							</th>
							<th>
								<abbr title="Minutes">Mins</abbr>
							</th>
							<th>
								<abbr title="Revenue">Rev</abbr>
							</th>
						</tr>
						</thead>
						<tbody>
                            <tr v-for="(psychic, index) in psychics" :key="psychic.ext">
								<td width="5%">
                                    {{ index+1 }}
								</td>
								<td>
									<router-link :to="'/psychics/' + psychic.user_id">{{ psychic.user_name }}</router-link>
								</td>
								<td class="is-hidden-mobile">
									{{ psychic.phone_extension }}
								</td>
								<td>
									{{ psychic.tot_calls }}
								</td>
								<td>
									{{ psychic.tot_mins }}
								</td>
								<td>
									${{ psychic.total_revenue.toLocaleString("en-US")}}
								</td>
                            </tr>
						</tbody>
						</table>
						<div class="column has-text-centered">
							<router-link class="button is-primary is-small" to="/statistics">Statistics</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			psychics: Array
		}
	}
</script>